const studentData = {
    "chineseName": "陳志明",
    "englishName": "Zhiming Chen",
    "mobilePhone": "0912-112-221",
    "mailingAddress": {
        "city":"taipei",
        "district":"中正區",
        "street":"忠孝東路",
        "zipCode":"100"
    },
    "email": "chenZhiming@gmail.com"
}

export default studentData;